module.exports = __webpack_public_path__ + "img/1f989.8f1d4d7.svg";